import { Box, Grid, Input, Stack, Switch, Typography } from '@mui/material';
import { toNumber } from 'lodash';
import { useState } from 'react';
import { AssemblyLayout } from 'src/components/assemblyLayout';
import { AssemblyScreen } from 'src/components/assemblyScreen';
import { AssemblyScreenSection } from 'src/components/assemblyScreenSection';
import { useGetLayoutScreens, useGetScreenSections } from 'src/hooks';
import { lang } from 'src/utils';

export const LayoutsPage = () => {
  const { data: screens = [] } = useGetScreenSections();
  const { data: layouts = [] } = useGetLayoutScreens();

  const [screenMode, setScreenMode] = useState<'screen' | 'section'>('section');
  const [screenEditable, setScreenEditable] = useState(false);
  const [sectionEditable, setSectionEditable] = useState(false);
  const [scale, setScale] = useState(0.15);

  return (
    <Box style={{ height: '100vh', overflow: 'auto' }}>
      <Stack>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography>{lang.scale}</Typography>
          <Input
            value={scale}
            size="small"
            onChange={(event) => setScale(toNumber(event.target.value))}
            inputProps={{
              step: 0.01,
              min: 0,
              max: Infinity,
              type: 'number',
            }}
          />
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center">
          <Typography>{lang.screenMode}</Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>{lang.screen}</Typography>
            <Switch
              checked={screenMode === 'section'}
              onChange={() =>
                setScreenMode((state) =>
                  state === 'screen' ? 'section' : 'screen',
                )
              }
            />
            <Typography>{lang.section}</Typography>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center">
          <Typography>{lang.sectionEditable}</Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>{lang.off}</Typography>
            <Switch onChange={() => setScreenEditable((state) => !state)} />
            <Typography>{lang.on}</Typography>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center">
          <Typography>{lang.sectionEditable}</Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>{lang.off}</Typography>
            <Switch onChange={() => setSectionEditable((state) => !state)} />
            <Typography>{lang.on}</Typography>
          </Stack>
        </Stack>
      </Stack>

      <Grid container spacing={2} alignItems="flex-start" direction="column">
        {layouts.map((layout) => (
          <Grid item xs key={layout.id}>
            <Typography>{`${layout.id} - ${layout.name}`}</Typography>
            <AssemblyLayout>
              {layout.screens.map((screen, index) => (
                <AssemblyScreen
                  key={screen.name + index}
                  height={screen.height}
                  width={screen.width}
                  scale={scale}
                  selectable={screenEditable}
                  type="screen">
                  {screen?.sections.map((section, index) => (
                    <AssemblyScreenSection
                      key={section.name + index}
                      section={section}
                      scale={scale}
                      selectable={sectionEditable}
                    />
                  ))}
                </AssemblyScreen>
              ))}
            </AssemblyLayout>
          </Grid>
        ))}
      </Grid>
      <Stack spacing={2}>
        <Grid container spacing={2}>
          {screens.map((screen) => (
            <Grid item key={screen.id}>
              <Typography>{`${screen.id} - ${screen.name}`}</Typography>
              <AssemblyScreen
                width={screen.width}
                height={screen.height}
                scale={scale}
                type={screenMode}
                selectable={screenEditable}>
                {screen.sections.map((section, index) => (
                  <AssemblyScreenSection
                    key={section.name + index}
                    section={section}
                    scale={scale}
                    selectable={sectionEditable}
                  />
                ))}
              </AssemblyScreen>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  );
};
